import React from 'react';
import * as PropTypes from 'prop-types';

import { t } from '../../../../../../utils/i18next';
import { numberToCurrency } from '../../../../../../utils/String';
import Tooltip from '../../../../general/Tooltip';

const translationBase = 'payables.total_side_bar.assist.service_fee';

const ServiceFeeTooltip = ({ serviceFee }) => {
  return (
    <Tooltip
      text={t(`${translationBase}.text`, { val: numberToCurrency(serviceFee) })}
      tooltipTextContent={t(`${translationBase}.tooltip`)}
    />
  );
};

ServiceFeeTooltip.propTypes = {
  serviceFee: PropTypes.number.isRequired
};

export default ServiceFeeTooltip;
